import { Box, HStack, Text } from "@chakra-ui/react";
import { INHERITANCE_STATE } from "../models/scoringModel";

/**
 * Renders the 3 inheritance states from the recruitment-form side of the
 * spec. Purely presentational -- the host owns the actual override mutation
 * via `onCustomizeForRecruitment`.
 */
const InheritanceBadge = ({ state, onCustomizeForRecruitment, labels }) => {
    if (state === INHERITANCE_STATE.LOCAL) return null;

    if (state === INHERITANCE_STATE.LOCKED) {
        return (
            <Box borderRadius={6} border="1px solid" borderColor="border.primary" bg="bg.dark" px={3} py={2}>
                <Text fontSize="xs" color="text.grey" fontWeight={600}>{labels.sourceScenario}</Text>
                <Text fontSize="xs" color="text.grey">{labels.sourceScenarioLocked}</Text>
            </Box>
        );
    }

    if (state === INHERITANCE_STATE.OVERRIDABLE) {
        return (
            <HStack justify="space-between" borderRadius={6} border="1px solid" borderColor="border.primary" bg="bg.dark" px={3} py={2}>
                <Text fontSize="xs" color="text.grey" fontWeight={600}>{labels.sourceScenario}</Text>
                <Box
                    as="button"
                    type="button"
                    onClick={onCustomizeForRecruitment}
                    px={2.5}
                    py={1}
                    borderRadius={6}
                    fontSize="xs"
                    color="purple.300"
                    border="1px solid"
                    borderColor="purple.500"
                    _hover={{ bg: "purple.900" }}
                >
                    {labels.customizeForRecruitment}
                </Box>
            </HStack>
        );
    }

    if (state === INHERITANCE_STATE.OVERRIDDEN) {
        return (
            <Box borderRadius={6} border="1px solid" borderColor="purple.500" bg="purple.950" px={3} py={2}>
                <Text fontSize="xs" color="purple.300" fontWeight={600}>{labels.sourceRecruitment}</Text>
            </Box>
        );
    }

    return null;
};

export default InheritanceBadge;
